import React, { Component } from 'react';
import config from 'react-global-configuration';
// Importação do Router
import { Link } from 'react-router-dom';
// Importação da tabela
import RequestApi from '../Miscelania/RequestApi';

import Overlay from '../Miscelania/Overlay';


class Suspenso extends Component {

  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      suspended_message: '0',
      prediction: '0',
    };
    // Handlers
    this.handleAlert = this.handleAlert.bind(this);

    this.loadData = this.loadData.bind(this);
  }

  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  componentDidMount() {
    this.loadData();
  }

  loadData() {
    var headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json',
    };
    this.handleAlert('', '', 'open');
    fetch(config.get('api_sigtrip') + '/get/suspended_info', { method: 'GET', mode: 'cors', headers: headers }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
      this.setState({suspended_message: responseJson.data.suspended_message, prediction: responseJson.data.prediction});
      this.handleAlert('', '', 'closed');
    }).catch((error) => {
      console.error(error);
    });
  }

  render() {
    return (
<div className="user-wrapper" style={{backgroundImage: "url('" + config.get('cdn_sigtrip') + "/images/modal_background.png'), url('" + config.get('cdn_sigtrip') + "/images/fundo-login.jpg')"}}>
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="user-layer-suspended">
    <div className="container">
      <div className="row">
  			<div className="col-md-4 col-md-offset-4">
  				<div className="user-content text-center">
            <img src={config.get('cdn_sigtrip') + '/images/logo2.png'} alt="SIGTREIN" />
  					<h3>Sistema suspenso para manutenção</h3>
  					<h5><strong>Atualização:</strong> {this.state.suspended_message}</h5>
  					<p><em><strong>Previsão de volta:</strong> {this.state.prediction}</em></p>
  					<br/>
            <p>
  			      <Link className={'btn btn-success'} to='/usuario/login'>
  			        <i className="fa fa-fw fa-refresh"></i> Recarregar
  			      </Link>
            </p>
  				</div>
  			</div>
      </div>
		</div>
  </div>
</div>
    );
  }
}

export default Suspenso;



// WEBPACK FOOTER //
// ./src/Components/Users/Suspenso.js